/* eslint-disable react/destructuring-assignment */

import { Component } from 'react';
import PropTypes from 'prop-types';
import * as Sentry from '@sentry/nextjs';

import Error500 from '@routes/Error500';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    Sentry.captureException(error);
  }

  render() {
    return this.state.hasError ? <Error500 /> : this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ErrorBoundary;
